import { ToastOptions } from 'react-hot-toast'

export const toastConfig: ToastOptions = {
  position: 'bottom-right',
  duration: 4000,
}

export const toastContainerStyles: React.CSSProperties = {
  bottom: '95px',
}
